module.exports = __webpack_public_path__ + "fonts/OpenSans400italic.30bc0c77.eot";